import { Request } from '../request';
import { IGetRewardReferralsListInput } from 'types/referral';

export const getProviderReferralInfo = () => Request.get({ url: '/schedule-server/referralPrograms/getInfo' });

export const generateProviderReferralLink = () => Request.get({ url: '/schedule-server/referralPrograms/getReferralLink' });

export const getProviderRewardReferralsList = (data: IGetRewardReferralsListInput) => Request.post({ url: '/schedule-server/referralProviderRewardsRecord/pageList', params: data });
